/**
 * Чистые функции по правилам ТЗ: допустимые сложности, прогресс разблокировки, правило «собран раз».
 */

import type { Difficulty } from '../data/types';

/** Пороги собранных пазлов для разблокировки сложности в Collection rebuild. */
const UNLOCK_252_AT = 5;
const UNLOCK_448_AT = 15;
const UNLOCK_1200_AT = 30;

export interface AllowedDifficultiesParams {
  source: 'daily' | 'pack';
  packOwned?: boolean;
  isFreeOrRewarded?: boolean;
  isCollectionRebuild?: boolean;
  collectedCount?: number;
}

/**
 * Допустимые сложности для входа в пазл (текущий этап):
 * tutorial: 16 (задаётся в сцене туториала), daily: 45, pack/collection: 24.
 */
export function getAllowedDifficultiesForEntry(
  params: AllowedDifficultiesParams
): Difficulty[] {
  const { source } = params;

  if (source === 'daily') {
    return [45];
  }

  return [24];
}

export interface NextDifficultyUnlockProgress {
  nextDifficulty: 252 | 448 | 1200 | null;
  current: number;
  target: number | null;
}

/**
 * Прогресс до следующей разблокировки сложности (для Collection rebuild).
 * Для отображения вида «Собрано 12/15 до сложности 448».
 */
export function getNextDifficultyUnlockProgress(
  collectedCount: number
): NextDifficultyUnlockProgress {
  if (collectedCount < UNLOCK_252_AT) {
    return { nextDifficulty: 252, current: collectedCount, target: UNLOCK_252_AT };
  }
  if (collectedCount < UNLOCK_448_AT) {
    return { nextDifficulty: 448, current: collectedCount, target: UNLOCK_448_AT };
  }
  if (collectedCount < UNLOCK_1200_AT) {
    return { nextDifficulty: 1200, current: collectedCount, target: UNLOCK_1200_AT };
  }
  return { nextDifficulty: null, current: collectedCount, target: null };
}

/**
 * Правило «собран раз»: пазл считается собранным по картинке, если собран хотя бы раз на любой сложности.
 */
export function markCollectedOnceRule(completedAtLeastOnceOnAnyDifficulty: boolean): boolean {
  return completedAtLeastOnceOnAnyDifficulty;
}
